import { render } from "./SyncHistory.vue?vue&type=template&id=79b4fb2a&scoped=true"
import script from "./SyncHistory.vue?vue&type=script&lang=js"
export * from "./SyncHistory.vue?vue&type=script&lang=js"

import "./SyncHistory.vue?vue&type=style&index=0&id=79b4fb2a&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b4fb2a"]])

export default __exports__